import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import StepBackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/StepBackwardOutlined";
import AntdIcon from "../components/AntdIcon";
var StepBackwardOutlined = function StepBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: StepBackwardOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  StepBackwardOutlined.displayName = 'StepBackwardOutlined';
}
export default /*#__PURE__*/React.forwardRef(StepBackwardOutlined);